import React from 'react'
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';
import { BankTab,BankCardTabs } from './bankIntegration.style';
import { gql,useQuery } from '@apollo/client';
import {  FlexyRow, FlexyRowJustify } from '../home/home.style';
import AddBankButton from './widgets/addBankButton';
import { Spinner } from 'evergreen-ui';
import RefreshButton from '../../../../widget/styledComponents/refreshButton';
import DeleteBankButton from './widgets/deleteBankButton';
import SetBankAsDeafultButton from './widgets/setAsDefault';




export const FETCH_MY_BANKS = gql`
query FacilityManager {
  facilityManager {
    bankAccounts {
      _id
      accountNumber
      accountName
      bankCode
      bankName
      isPrimary
    }
  }
}
`;

function BankIntegrationPageWidget() {
const { loading,error,data }  = useQuery(FETCH_MY_BANKS);
if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
const options = data.facilityManager.bankAccounts.map((opt) => (
    <BankTab>
        <FlexyRowJustify 
            style={{
                justifyContent:"end"
            }}
            className={opt.isPrimary?'mt-16':'mt-25'}
        >
            {opt.isPrimary
                ?<i className='material-icons'>verified</i>
                :""
            }
        </FlexyRowJustify> 
        <div className='row '>
            <div className='col s12 left'>
                <h6><b>{opt.bankName}</b></h6>
                <h6>{opt.accountNumber}</h6>
                <h6>{opt.accountName}</h6>
            </div>
        </div>
        <FlexyRowJustify
        className='mb-16'
        style={{
            justifyContent:"space-between"
        }}
        >
            <DeleteBankButton id={opt._id}/>
            { !opt.isPrimary &&
                <SetBankAsDeafultButton id={opt._id}/>
            }
        </FlexyRowJustify>
    </BankTab>
  )
);
  return (
    <div className=''>
        <div className='row mt-25'>
            <div className='col s12 l10'>
                <PageTitleText>
                    Bank 
                </PageTitleText>
            </div>
            <div className='col s12 l2 '>
                {/* <RefreshButton className="right"/> */}
                <FlexyRowJustify 
                    style={{
                        justifyContent:"end"
                    }}
                >
                    <RefreshButton />
                </FlexyRowJustify> 
            </div>
        </div>  
        <FlexyRow>
            <BankCardTabs>
                <FlexyRowJustify>
                    {/*  */}
                </FlexyRowJustify> 
                <div className='row mt-25'>
                    <div className='col s12 center'>
                        <h6><b>Add Bank</b></h6>
                    </div>
                </div>
                <div className='row'>
                    <div className='col s12 center'>
                        <AddBankButton />
                    </div>
                </div>
            </BankCardTabs>
            {options}
        </FlexyRow>
    </div>
  )
}

export default BankIntegrationPageWidget






